
import 'element-ui/lib/theme-chalk/time-picker.css';
import 'element-ui/lib/theme-chalk/icon.css';

import { Component , Vue ,Prop} from "vue-property-decorator";
@Component
export default class seckillDetailModal extends Vue {
    @Prop() private roomData!: any;
    @Prop() private seckillItem!: any;
    @Prop() private detailType!: any;
    params:any={
        id:'',
        auditStatus:'',//活动状态
        activityInfo:{
            roomId:'',
            sceneId:'',
            activityCode:'',//活动编码
            activityName:'',//活动名称
            activityTheme:'直播秒杀',//活动主题
            startTime:'',//活动开始时间
            endTime:'',//活动结束时间
            salesPromotion:'1',//预算类型  1 商家承担   2  邮乐/第三方承担 
            itemUserLimitNum:'',//用户单品活动期间内限购
            allGoodsLimitNum:'',//用户所有商品活动期间内限购
        },
        activityGoods:[{
            itemId:'',//商品id
            stock:0,//秒杀库存
            addStorageNum:'',//追加秒杀库存
            listingSeckillPrice:'',//秒杀价
            listingIdErr:false,
            priceErr:false,
            stockErr:false
        }],
    }
    isClick:boolean=true //是否可以点击
    times:any=''
    isSeckillManage:boolean = true // 弹窗boolean
	api:any={
        seckillActivityApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/seckillActivity/saveSeckillActivity",//创建、修改活动
        seckillDetailApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/seckillActivity/detail",//秒杀活动详情
        seckillGoodsApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/seckillActivity/validateMarketingCheck",//秒杀商品校验
	}
	mounted() {
        if (this.seckillItem.id) {
            this.getDetailData()
        }else{
            console.log(this.roomData);
            
            this.params.activityInfo.roomId = this.$route.params.id
            this.params.activityInfo.sceneId = this.roomData.scene_id
        }
		// this.getOrderListData()
	}
    getDetailData(){//获取秒杀活动详情
		this.fetch({
			url: this.api.seckillDetailApi + '?id=' + this.seckillItem.id,
			method: "get",
		}).then((res:any) => {
            this.params = Object.assign(this.params, res || {})
            this.params.activityInfo.roomId = this.$route.params.id
            this.params.activityInfo.sceneId = this.roomData.scene_id
            !this.params.activityGoods && (this.params.activityGoods = [{
                itemId:'',//商品id
                stock:0,//秒杀库存
                addStorageNum:'',//追加秒杀库存
                listingSeckillPrice:'',//秒杀价
                listingIdErr:false,
                priceErr:false,
                stockErr:false
            }])
            this.times = [this.params.activityInfo.startTime,this.params.activityInfo.endTime]
            console.log(this.params);
		})	        
    }
    inspect(){//数据检查
        if (this.params.activityInfo.salesPromotion == 1) {//商家承担
            if (!this.params.activityInfo.activityName) {
                this.$toast("请输入活动名称")
                return false
            }
            if (!this.params.activityInfo.activityTheme) {
                this.$toast("请输入活动主题")
                return false
            }
            console.log(this.times);
            if (!this.times) {
                this.$toast("请选择活动时间")
                return false
            }else{
                this.params.activityInfo.startTime = this.times[0]
                this.params.activityInfo.endTime = this.times[1]
            }
            for (let i = 0; i < this.params.activityGoods.length; i++) {
                const goods = this.params.activityGoods[i];
                if (!(goods.itemId && goods.addStorageNum && goods.listingSeckillPrice) && (this.detailType == 'create')) {
                    this.$toast("请完善商品信息");
                    goods.listingIdErr = true
                    goods.priceErr = true
                    goods.stockErr = true
                    return false
                }
            }
        }else{
            if (!this.params.activityInfo.activityCode) {
                this.$toast("请输入活动编码")
                return false
            }            
        }
        return true
    }
    formatter(good:any,type:string,num:number){//数字输入格式
        let str = good[type]
        if (!str) {
            good[type] = ''
            return false
        }
        if (num) {
            str && (str = str.replace(/\.\d{3}$/,''))
        }else{
            str=str.replace(/\D/g,'')/1
        }
        if (str<0) {
            str=0
        }
        good[type] = str + ''
    }
    formatterBlur(good:any,type:string){//价格过滤
        good.priceErr=true
        if (!good[type]) {
            good[type] = ''
            return false
        }
        good[type] = good[type]/1
        if (type == 'listingSeckillPrice') {
            this.itemSetFormatter(good)
        }
    }
    itemSetFormatter(good:any,index?:number){//商品设置校验
        if (!this.times) {
            this.$toast('请先选择活动时间')
            good.itemId = ''
            return false
        }
        if (!good.itemId) {
            good.listingIdErr=true
            return false
        }
        if (!good.listingSeckillPrice) {
            good.priceErr=true
            return false
        }
        console.log(this.params.activityGoods);

        let url = `${this.api.seckillGoodsApi}?itemIdList=${good.itemId}&listingSeckillPrice=${good.listingSeckillPrice}&startTime=${this.times[0]}&endTime=${this.times[1]}&activityCode=${this.params.activityCode}`
        this.fetch({
            url: url,
            method: "get",
        }).then((res:any) => {

        }).catch((err:any)=>{
            good.itemId = ''
            good.listingSeckillPrice = ''
            this.$toast(err.msg)
        })	
    }
    close(query:boolean){
        this.$emit('closeDetail',query)
    }
    releaseActivity(){//修改/发布秒杀活动
        if (this.inspect()) {
            if (!this.isClick) {
                this.$toast("正在发布，请不要重复提交")
                return false
            }else{
                this.isClick = false
            }
            this.fetch({
                url: this.api.seckillActivityApi,
                data:this.params,
                method: "post",
                // headers: {
                //     'Content-Type': 'application/json'
                // },
                noQS:true,
                formJson:true
            }).then((res:any) => {
                this.$toast("发布成功")
                this.isClick = true
                this.close(true)
            }).catch((err:any)=>{
                this.isClick = true
                this.$toast({message:err.msg,duration:5000})
            })		
        }
    }
}
